import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'fl-banner-announcement-buttons',
  template: ` <ng-content select="fl-button"></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerAnnouncementButtonsComponent {}
